<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label">
        {{label}}
    </mat-label>
    <div class="st-text-field__display"
        *ngIf="showLinks"
         [class.st-text-field__display--edit]="inEditMode"
         innerHTML="{{displayValue | linky : {stripPrefix: false} | highlight : textToHighlight: inEditMode }}"></div>
    <input matInput
           #control
           [disabled]="disabled"
           [ngModel]="value"
           [class.st-text-field__input--edit]="!inEditMode"
           [placeholder]="label || placeholder"
           (change)="onValueChanged()"
           (ngModelChange)="onNgModelChanged($event)"
           (blur)="onBlur($event)"
           (focus)="onFocus($event)"
           (keyup)="keyPressed($event)"
           [required]="required"
           [maxLength]="maxLength"
           [type]="type" />
    <mat-hint *ngIf="hint">
        {{hint}}
    </mat-hint>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>
